// extracted by mini-css-extract-plugin
export var heroLogoItem = "hero-customer-logos-module--heroLogoItem--31ade";
export var heroLogosContainer = "hero-customer-logos-module--heroLogosContainer--1e2b2";
export var heroLogosGrid = "hero-customer-logos-module--heroLogosGrid--b5599";
export var heroLogosTitle = "hero-customer-logos-module--heroLogosTitle--a077f";